(function($) {

    // $(".sidebar-news-items-slider").slick({
    //     arrows: false,
    //     dots: false,
    //     autoplay: true,
    //     autoplaySpeed: 5000,
    //     // fade: true,
    //     rows: 0,
    // });

    function scrollWith(){
        var scrollMiddle = $(window).scrollTop() + ($(window).height() / 2);

        $('.scrollWith').each(function(){

            if( $(this).outerHeight() >= $(this).parent().innerHeight() || $(window).width() < 990 ){
                $(this).css({position: '', top: '', width: ''});
                return;
            }

            var parentTop = $(this).parent().offset().top;
            var parentBottom = $(this).parent().innerHeight() - $(this).outerHeight();
            var thisMiddle = scrollMiddle - parentTop - ($(this).outerHeight() / 2);
            var parentOffsetBottom = $(this).parent().innerHeight() + $(this).parent().offset().top - ($(this).outerHeight() / 2) - 50;
            var thePosition = 'fixed';
            var theTop = $(window).height() / 2 - ($(this).outerHeight() / 2);
            var theWidth = $(this).parent().innerWidth();

            if(thisMiddle < 0){
                theTop = 0;
                thePosition = 'static';
            }

            if(scrollMiddle > parentOffsetBottom){
                theTop = parentBottom - 50;
                thePosition = 'absolute';
            }


            $(this).css({position: thePosition, top: theTop, width: theWidth});
        });

    }
    $(window).on('scroll load resize',function(){
        if($('.sidebar .sidebar-navigation').outerHeight() >= $('.sidebar').outerHeight()){

        } else{
            scrollWith();
        }

    });

})( jQuery );

